export default __webpack_public_path__ + "static/media/gz.cbc4bf69.jpg";